import { ButtonGroup } from '@chakra-ui/react';

import Button from 'components/Button';
import Modal from 'components/Modal';
import Text from 'components/Text';

interface SwitchConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  targetName: string;
}

const SwitchConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  targetName,
}: SwitchConfirmModalProps) => (
  <Modal
    size="md"
    isOpen={isOpen}
    onClose={onClose}
    header={
      <Text fontSize="xLarge" fontWeight="semibold">
        Switch to {targetName}?
      </Text>
    }
    footer={
      <ButtonGroup>
        <Button onClick={onClose} scheme="ghost">
          <Text fontWeight="semibold" opacity="secondary">
            Cancel
          </Text>
        </Button>
        <Button
          scheme="primary"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          Switch
        </Button>
      </ButtonGroup>
    }
  >
    <Text fontWeight="regular">
      Switching to <strong>{targetName}</strong> will replace your current code with a starter
      template. Your existing code will be lost.
    </Text>
  </Modal>
);

export default SwitchConfirmModal;
